import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { SmartRenderer } from '../../component-interface';
import { POINTER, PXSTRING, pluckNumber } from '../../lib/';
import MenuItem from './menu-item';
import { DEFAULT_TIMEOUT } from './helper';
import { addDep } from '../../../../fc-core/src/dependency-manager';
var AUTO = 'auto',
    BLOCK = 'block',
    NONE = 'none';

function createMenuItem(a) {
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var c, d, e, f;
  if (d = a.attachChild(MenuItem, 'item', b.id), d.configure(b), b.menu instanceof Array && (f = b.menu.length)) for (c = d.attachChild(MenuItemContainer, 'subContainer', 'subContainer'), a.config.hasSubMenu = !0, c.configure(), e = 0; e < f; e++) {
    c.addItem(b.menu[e]);
  }
}

addDep({
  name: 'manuItemContainerAnimation',
  type: 'animationRule',
  extension: {
    "*.menuItemContainer.menuItemContainer": null
  }
});

var MenuItemContainer =
/*#__PURE__*/
function (_SmartRenderer) {
  _inherits(MenuItemContainer, _SmartRenderer);

  function MenuItemContainer() {
    _classCallCheck(this, MenuItemContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(MenuItemContainer).apply(this, arguments));
  }

  _createClass(MenuItemContainer, [{
    key: "configureAttributes",
    value: function configureAttributes() {
      var a = this,
          b = a.config;
      a.setStyle(), b.counter = 0, b.hasSubMenu = !1, b._defaultStyle = {
        position: 'absolute',
        "z-index": 50,
        top: 0 + PXSTRING,
        right: AUTO,
        left: AUTO,
        overflow: 'hidden',
        background: '#ffffff',
        border: '1px solid #646464',
        "box-shadow": '#999999 2px 2px 5px',
        padding: '5px 3px',
        display: 'none'
      };
    }
  }, {
    key: "setStyle",
    value: function setStyle() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b = this,
          c = b.config;
      c.hoverOverStyle = a.hoverOverStyle || {
        background: '#333333',
        color: '#FFFFFF',
        cursor: POINTER
      }, c.hoverOutStyle = a.hoverOutStyle || {
        background: '#FFFFFF',
        color: '#000000'
      };
    }
  }, {
    key: "show",
    value: function show() {
      var a,
          b = this,
          c = b.config,
          d = b.getFromEnv('chart'),
          e = b.getLinkedParent(),
          f = e.config,
          g = pluckNumber(f.scale, 1.5),
          h = {
        x: f.x,
        y: f.y,
        width: f.width * g,
        height: f.height * g
      },
          i = +d.getFromEnv('chartWidth'),
          j = b.getGraphicalElement('menu', 'menu').element,
          k = j.style;
      clearTimeout(c.hideTimer), k.display = 'block', a = j.offsetWidth, a + h.x > i ? (k.left = AUTO, k.right = i - h.x - h.width + PXSTRING) : (k.left = h.x + PXSTRING, k.right = AUTO), k.top = 2 * h.y + h.height + PXSTRING, k.bottom = AUTO, k.display = BLOCK;
    }
  }, {
    key: "hide",
    value: function hide() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b,
          c = this,
          d = c.config,
          e = c.getGraphicalElement('menu', 'menu').element;
      a.instant ? e.style.display = NONE : (b = pluckNumber(a.timeout, DEFAULT_TIMEOUT), d.hideTimer = setTimeout(function () {
        e.style.display = NONE;
      }, b));
    }
  }, {
    key: "addItem",
    value: function addItem() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      createMenuItem(this, a);
    }
  }, {
    key: "draw",
    value: function draw() {
      var a = this,
          b = a.config;
      a.addGraphicalElement({
        el: 'html',
        attr: {
          type: 'div'
        },
        css: b._defaultStyle,
        component: a,
        label: 'menu',
        id: 'menu'
      }), a.addEventListener('mouseover', this.show), a.addEventListener('mouseout', this.hide);
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'menuItemContainer';
    }
  }, {
    key: "getType",
    value: function getType() {
      return 'menuItemContainer';
    }
  }]);

  return MenuItemContainer;
}(SmartRenderer);

export default MenuItemContainer;